<template>
  <div class="terms__wrap">
    <Breadcrumb :config="breadcrumb" />
    <div class="m-useful-info layout">
      <div class="m-useful-info__container">
        <div class="m-useful-info__title heading-h2">有用的信息</div>
        <div class="clearfix">
          <div class="m-useful-info__menu-container menu-toggler" @click="clickMenu">
            <div>条款与条件</div>
            <span :class="showMenu?'selectboxit-arrow-up':'selectboxit-arrow-down'"></span>
          </div>
          <div class="c-toggler-content" v-if="showMenu">
            <ul class="c-refinement__values">
              <li
                :class="['c-refinement',selected==item.href?'selected':'']"
                v-for="item in menuList"
                :key="item.index"
                @click="clickSelect(item)"
              >
                <span>{{item.name}}</span>
                <span class="checkmark" v-if="selected==item.href">
                  <svg
                    class="svg-inline checkmark"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="15px"
                    height="15px"
                    viewBox="0 0 488.878 488.878"
                    style="enable-background:new 0 0 488.878 488.878;"
                    xml:space="preserve"
                  >
                    <g>
                      <g>
                        <polygon
                          style="fill:#000;"
                          points="143.294,340.058 50.837,247.602 0,298.439 122.009,420.447 122.149,420.306 144.423,442.58 488.878,98.123 437.055,46.298        "
                        />
                      </g>
                    </g>
                  </svg>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div class="m-useful-info__main-content">
          <article>
            <p>欢迎访问Sisley法国希思黎中国官方网站</p>
            <p>根据本使用条款、我们的隐私权政策和您在网站上看到的与特定功能、特征或促销以及客户服务相关的其他条款政策以及希思黎对上述文件的不时更新（此类条款政策均被视为本使用条款的一部分并统称为“使用条款”），Sisley法国希思黎中国官方网站向您提供（网址为www.sisley.com.cn）的内容和服务。请仔细阅读本使用条款。您访问或使用“网站”，说明您已同意受本条款的约束。</p>
            <p>1 隐私权政策</p>
            <p>希思黎尊重希思黎网站所有访问者的隐私权，请查阅我们的隐私权政策,以便理解我们的隐私保护措施。</p>
            <p>(1)个人验证信息</p>
            <p>只有当访问者自愿为本网站提供时，本网站方可收集其姓名、地址、电子邮件等个人验证信息。除非根据希思黎无法掌控的情况，包括但不限于：相关法律法规或其它政府部门的命令，否则未经您的事先同意，希思黎不会将您的姓名、地址和电子邮件故意提供给第三方。</p>
            <p>(2)非个人身份信息</p>
            <p>若您接受服务，则可能会在您的计算机内产生cookie。Cookie无法让我们了解您的身份。它通常记录与您使用这台计算机浏览本网站有关的信息（您访问过的页面、访问的日期和时间等），以便我们能够在您之后访问时读取。我们向您告知，通过将网络浏览器设置为拒绝安装cookie或在安装这类文件前对您进行提醒，您可以避免cookie记录。</p>
            <p>(3)信息删除</p>
            <p>您可要求本公司从档案中删除与您有关的任何个人身份信息。如需提出此类要求，请写信至客服邮箱E-mail:cs@sisley.com.cn，本公司将会从档案中删除您的所有信息。</p>
            <p>(4)信息的准确性</p>
            <p>我们尽量做到在“网站”上对产品的描述准确无误；然而，我们无法保证产品说明、颜色或“网站”上的其他内容完全精确、完整、现时或毫无差错。如果我们在“网站”出售的产品和“网站”描述有所出入，您可根据希思黎公司退款程序提出退货申请交由希思黎审核。</p>
            <p>(5)附加信息</p>
            <p>我们无法保证在互联网上传送数据绝对安全。希思黎控制范围以外的第三方可能会在未经希思黎许可或知晓的情况下，访问或截取数据传送或私人通讯。希思黎会采取一切可能措施保护您的个人信息。但本公司无法确保或担保您向本公司传送的信息安全，这类传送的风险由您自行承担。</p>
            <p>(6)儿童隐私</p>
            <p>如果您未满18岁，您可以浏览我们的“网站”，但不能向我们提供您的个人信息。也就是说，您不能注册或购买产品。“网站”不是为未满18岁人士设计，我们不会在明知的情况下收集任何未满18岁人士的个人信息。如果我们得知我们不慎获得未满18岁访问者的个人信息，我们会从记录中将其删除。</p>
            <p>(7)雇佣关系</p>
            <p>如果您向我们提供有关雇佣信息，如简历，我们会对此类个人信息保密，并只在考虑与您的目前或将来的与我们或我们的关联企业的雇佣机会时依此信息联系您。“关联方”是指一家通过一个或多个中间人直接或间接控制我公司或被我公司控制，或与我公司共同受到控制的个人或实体。我们会保留您的信息以便日后就有关雇佣机会与您联系，直到您告知不再希望我们保留您的信息。</p>
            <p>(8)客户资料的保密性</p>
            <p>保护用户隐私是本站的一项基本政策，本站保证不故意对外公开或向第三方提供用户注册资料及用户在使用网络服务时存储在网的非公开内容，但下列情况除外：</p>
            <p>♦事先获得用户的明确授权；</p>
            <p>♦根据有关的法律法规要求；</p>
            <p>♦按照相关政府主管部门的要求；</p>
            <p>♦为维护社会公众的利益；</p>
            <p>♦为维护网站的合法权益。</p>
            <p>2 您的帐户信息及安全</p>
            <p>若您是18岁以上人士，您可以在我们的“网站”注册；如果您未满18岁，请不要注册。</p>
            <p>如果您已满18岁且注册，您的账户会有一个电子邮件地址/用户名和密码，您应负责对自己的账户、用户名和密码保密并限制他人使用您的电脑登陆您的账户。您应负责保证账户相关信息现时、完整、准确和真实，并为在您的帐户/用户名和/或密码项下发生的所有行为负责。您同意只提供现时、完整、准确和真实的信息。</p>
            <p>3 供个人使用的产品和服务</p>
            <p>我们通过本网站自身或通过指定的经销商提供给您的任何产品和服务及其样品仅供您个人享用。任何从我方购买或收到的产品均不可出售或转售。</p>
            <p>4 与购买有关的政策和程序</p>
            <p>在本网站订购产品通过第三方服务商运作和完成。一切关于产品和订单的查询都应依照第三方服务商的相关政策和程序向其发出。若须查看有关在该站发出订单的政策和程序（如订单处理、送货程序、退换货等），请-联系官网在线客服。</p>
            <p>5 知识产权和版权</p>
            <p>"网站”的所有内容及其“视觉和感觉”，包括但不限于商标、标志、服务商标、文字、图表、标识、按钮图标、图像、声音片段、数据汇编和软件以及文献编汇（合称“内容”）均为希思黎、我们的关联公司、合作伙伴和许可方的财产，并受包括著作权法和商标法在内的法国、中国和国际法律的保护。希思黎对本网站上的所有资料具备完整知识产权，或已从第三方获得在本网站使用这些资料的有效权限。希思黎还拥有本网站上所使用的所有商标、服务标志、营业名称与图样标志的合法知识产权。</p>
            <p>未经我们事先明确书面同意，“网站”的内容或任何其他部分均不得为任何目的被全部或部分使用、再版、复制、仿制、出售、转售、访问、修改或以其他方式利用。这项禁令还包括在其它网站上对本网站的内容进行分帧以及未经授权的链接。</p>
            <p>我们尊重他人的知识产权。如果您认为某一作品在本网站上被抄袭而构成著作权侵权，请通知我们有关侵权诉求，我们会及时跟进处理。</p>
            <p>6 第三方链接</p>
            <p>我们不对“网站”之外的页面或与“网站”相链接的其他网站的内容负责。可能会有第三方网站与本网站进行连接，希思黎并不认可这类网站所提供的商品或服务。希思黎对这类网站提供的信息准确性以及这类网站所提供或从这类网站购买的商品或者服务概不负责。希思黎无需对与本网站连接的网站内容及您点击该链接而产生的一切行为及后果承担任何法律责任。您应仔细阅读所有您访问的“网站”之外的页面及其他网站的使用条款。</p>
            <p>7 特别项目、功能和活动</p>
            <p>“网站”可能会提供某些特别项目、功能和活动（比如竞赛、抽奖或其他活动），这些活动会(1)适用除本条款之外的使用规则、条款和/或政策；并(2)由我们或第三方提供。若您选择参与这些活动，我们会通知您，您同意参与活动适用另外单独的使用规则、条款和/或政策。</p>
            <p>8 提交资料</p>
            <p>我们一般谢绝未经请求的建议和想法。然而，您向我们提供的任何询问、反馈、建议、想法或其他信息（合称“提交资料”）将作为非私有、非保密的资料处理。在遵守我们隐私权政策的前提下，我们可以以任何形式、媒介或技术复印、使用、复制、修改、改编、公布、出售、转让、翻译、制造衍生作品、分发及展示任何提交资料，不论上述提交资料是目前为人所知或今后开发的，单独的或是其他产品的一部分，我们也可在我们的产品或服务上或结合产品或服务而应用提交资料。每一个因特网用户都有义务保护因特网的安全。您保证上述提交资料并不构成或包含软件病毒、商业招揽、链式信函、群发邮件或任何形式的“垃圾信息”。您不可使用虚假的电子邮件地址，假冒任何个人或实体，或以别种方式就任何提交资料的来源误导我们。您同意就您违反本条及而导致的或因提交资料发生的任何损失向我们赔偿。</p>
            <p>9 您的义务和责任</p>
            <p>您在访问或使用任一“网站”时，应当遵守本使用条款和“网站”上张贴的访问使用特别警示或指示。您应当根据法律和惯例善意行事。您不应当从事以下行为：</p>
            <p>♦框定或使用成帧技术框住本网站或其任何部分；</p>
            <p>♦再发表、再发布、销售、许可或下载本网站或任何内容，（除暂存或查看本网站所必需）；</p>
            <p>♦除个人使用以外对网站或其内容作其他任何用途；</p>
            <p>♦修改、反向工程或根据本网站或任何内容创作衍生作品；</p>
            <p>♦为您个人或其他方收集帐户资料或其他用户的个人身份数据；</p>
            <p>♦在任何内容上使用任何元标记(Megatags)或任何其他“隐藏文字”；</p>
            <p>♦使用软件机器人、搜索蜘蛛、爬行搜索技术或类似的数据收集和提取工具，或采取可能给我们的信息基础设施造成不合理的负担或重负的任何其他手段。</p>
            <p>♦对“网站”或出现在“网站”上的任何内容或服务进行任何修改或改动，而且以任何方式损害“网站”的完整性和正常运作；</p>
            <p>♦传输、上载、发布、电邮或通过其他方式使得“网站”得到软件病毒、未经请求或授权的广告、商业招揽或促销性材料，包括链式信函、群发邮件或任何形式的“垃圾信息”；</p>
            <p>♦冒充任何个人或组织，或错误的陈述或通过其他方式表示您与任何个人或实体之间的关联关系；</p>
            <p>♦骚扰或袭击他人，包括挑起他人的袭击、诱骗或通过其他方式陷害他人，包括通过任何方式骚扰未成年人；</p>
            <p>♦伪造标题或通过其他方式假造标识符以隐藏任何使用者信息的来源；</p>
            <p>♦故意或非故意地违反任何适用的当地国家或国际法律；</p>
            <p>同时，当您向任一“网站”，尤其是希思黎网站传输、上载、发布、电邮或通过其他方式使得“网站”获得数据、文本、软件、音乐、声音、照片、表格、图像、录像、消息或其他材料，您须对这些信息全权负责。这意味着，信息的提交者，而并非我们，应对在任一“网站”提交的信息全权负责。您同意不进行、协助或鼓励他人向“网站”传输、上载、发布、电邮或通过其他方式使“网站”拥有以下信息：</p>
            <p>♦违背中国宪法所确定的基本原则的；</p>
            <p>♦危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
            <p>♦损害国家荣誉和利益的；</p>
            <p>♦煽动民族仇恨、民族歧视、破坏民族团结的；</p>
            <p>♦破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
            <p>♦散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
            <p>♦散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
            <p>♦侮辱或者诽谤他人，侵害他人合法权利的；</p>
            <p>♦含有虚假、诈骗、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容；</p>
            <p>♦您无法定权利、协议性权力或代理权发布该信息；</p>
            <p>♦您知道该信息是错误的、不准确或误导性的；</p>
            <p>♦您发布该信息获得了第三方的报酬；</p>
            <p>♦该信息侵犯了任何其他方的任何专利、商标、商业秘密、版权或其他所有权；</p>
            <p>♦含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的；</p>
            <p>♦其他任何对希思黎网上业务经营产生不利影响的行为。</p>
            <p>您确认并知晓，我们完全拥有拒绝发布或删除任何使信息的权利，并且我们保留修改、压缩、或删除任何信息的权利。在不限制上述说明和本使用条款中其他条款原则的前提下，我们拥有删除违反本使用条款或在其他方面有争议的信息，且对于任何违反本使用条款或对他人侵权的用户，我们保留无提前通知即拒绝对其服务的权利。同时，如果您由于疏忽或故意违反本条款中的任何规定，您应对希思黎、我们的关联公司、合作伙伴或许可方造成的损失和损害承担责任。</p>
            <p>10 侵犯著作权通知</p>
            <p>根据信息网络传播权保护条例，如果您相信受著作权保护的作品、表演和视听产品被复制从而构成侵犯著作权，请发送电子邮件或书面通知之我们的授权代理人并提供以下资料：提出侵权诉求的著作权所有人之授权代表的书面或电子签名；您认为被侵权的著作权作品的证明；您认为构成侵权的资料的描述和其在“网站”上的地址；您的地址、电话和电子邮件地址；构成侵权的初步证明材料；和书面声明您通知中的上述信息真实准确而且您是著作权所有人或其授权代表。</p>
            <p>有关著作权侵权请求通知，可以发送邮件至cs@sisley.com.cn。</p>
            <p>请注意：上述联系信息仅用于就有关侵犯受著作权保护的资料的事宜通知在Sisley法国希思黎中国官方网站。所有其他的询问不会经此渠道得到处理，而应请注意当发送电子邮件至cs@sisley.com.cn联络我们的客户服务组。</p>
            <p>11 声明和保证；责任限制</p>
            <p>本网站按现状提供。在适用法律允许的范围内，我们并不就本网站作任何形式（无论明示或暗示）的声明或保证。</p>
            <p>在适用法律允许的范围内，我们不为下述情况负责或承担责任，包括合同法、侵权法（包括故意或过失）或其他责任：</p>
            <p>♦业务中断；</p>
            <p>♦对本网站的访问延迟或访问中断；</p>
            <p>♦数据不传送、错误传送、讹误、破坏或被篡改；</p>
            <p>♦由于处理本网站上的网站外链接或因网站外链接的出现而发生的任何类型的损失或损害；</p>
            <p>♦您因使用本网站，包括超级链接出入第三方网站时，可能发生的计算机病毒、系统故障或失灵；</p>
            <p>♦任何不准确或有疏漏的内容；</p>
            <p>♦“网站”出售的产品和“网站”描述有所出入；</p>
            <p>♦其他任何在我们合理控制范围以外的事件。</p>
            <p>而且，在法律允许的最大范围内，我们将不为与本网站有关的任何类型的间接或结果性损害（包括利润损失）负责，不论诉讼形式是基于合同、侵权（包括故意或过失）或其他理论，即使我们接到可能发生该等损害的通知。</p>
            <p>12 补偿</p>
            <p>您同意对因您使用“网站”或违反本使用条款而给我们带来的任何损失, 损害给予保护及补偿,并使我们免于遭受任何损失。</p>
            <p>若您处的违反行为导致任何第三方提出权利主张、起诉或要求而产生的任何损失、损害或费用，包括合理的律师费，您承诺向我们作出保护和补偿，并使我们不受损失。</p>
            <p>您也同意对因您使用软件机器人、搜索蜘蛛、爬行搜索器或类似数据收集和提取工具，或您采取的给我们的信息基础设施造成不合理的负担或重负的任何其他手段而产生的任何损失、损害或费用，包括合理的律师费向我们作出补偿。</p>
            <p>13 争议</p>
            <p>对于与“网站”有关的任何争议和本使用条款所包含的您的权利和义务及所有行为应受中华人民共和国法律管辖。与您访问“网站”有关的任何形式的争议应提交给上海仲裁委员会（“仲裁委员会”）在上海进行仲裁，您接受该机构的管辖权和程序；但如果您以任何方式侵犯或可能侵犯我们（或我们的关联实体、合作伙伴或许可人）的知识产权或我们有基于衡平法的诉因，我们可在任何有适当管辖权的法院寻求禁令或其他适当的救济，您同意该法院的属人管辖权和属地管辖权。在本协议项下的仲裁应根据贸仲会届时有效的仲裁规则进行。仲裁裁决应具有约束力，并可在任何具有司法管辖权的法院作判决备案。在法律许可的最大范围内，本使用条款项下的任何仲裁不得与涉及受制于本使用条款的任何其他方的仲裁合并，无论是否以集体仲裁程序或其他方式提起。</p>
            <p>14 同意由网站公告或电邮形式接受电子通知</p>
            <p>您同意通过电子方式，包括但不限于电子邮件或“网站”上的通告，接受本使用条款提及的任何协议、通知、披露和其它通讯（合称“通知”）。您同意我们以电子方式提供给您的通知符合该等通知应当书面做出的法律要求。您必须发送电子邮件至E-mail：cs@sisley.com.cn并停止使用“网站”，来通知我们您不再同意以电子方式接受通知。在此情况下，所有根据本使用条款赋予您的权利应当自动终止。遗憾的是，我们无法向不同意以电子方式接受通知的用户提供“网站”的服务。</p>
            <p>请注意，本条同意接受通知的规定和一切您作出的接收销售通讯的选择不相关联。您对于是否接收销售通讯的选择由我们的隐私权条款来规定。</p>
            <p>15 一般规定</p>
            <p>我们可在任何时间通过在“网站”上公布的方式更改上述使用条款。任何更改在“网站”公布和发出更改通知之时立即生效并对使用方产生约束力。您对“网站”的继续使用构成您对所有该等更改的同意。</p>
            <p>如果您对本使用条款有任何问题，请发送电子邮件至E-mail：cs@sisley.com.cn与我们联系。</p>
            <p>其他注意事项：</p>
            <p>为了确保买卖双方的权益，希思黎敬请所有会员，在需要退货前请先在“订单管理”里提交退货申请，或联系官网在线客服填写相关申请。另外当希思黎受理您的退货情况后，请按退款流程填写相关申请清单，在收到货起的7天内（以快递公司的送货单上的收货日期为准）将商品退回，我们将以最快的速度妥善为您办理退款。（在希思黎未受理您的退货申请时，请不要把货品寄回。）</p>
            <p>建议您选择希思黎指定的快递公司（不建议使用平邮），这将会更快捷的收寄您退回的商品。我司指定的快递公司有顺丰，EMS，宅急送。</p>
            <p>退货规则</p>
            <p>一、顾客在本网站订购产品，凡收到货物后发现以下情形的，可以在签收之日起的7天内无条件退换货：</p>
            <p>1. 收到货物时即发现产品破损；</p>
            <p>2. 与顾客在网站上订购的产品不同；</p>
            <p>3. 收到货物时即发现产品已过期；</p>
            <p>凡出现上述情形，希思黎将退还相应的货款并承担因退换货而产生的运费。</p>
            <p>二、顾客在本网站订购产品，在收到货物后发现，订错了，或想换其他的产品，可以在签收之日起的7天内申请退换货，但必须满足以下条件：</p>
            <p>1. 退货产品的原包装未经拆开也未经使用；</p>
            <p>2. 退还的商品务必需跟收货时的原盒包装一样；</p>
            <p>3. 退还的产品不影响二次销售。</p>
            <p>凡出现上述情形，我们将退还相应的货款，但顾客需自行承担因退换货而产生的运费。</p>
            <p>在此情形下，顾客退还产品时，应将该产品正品相对应随附的产品体验装同时退回，若无法退回体验装的，则体验装的价值应由顾客承担，于退款中扣除。体验装的价值参照相应正品的价值，按照比例进行计算。</p>
            <p>我们有时会设定购买达到一定金额，赠送满额礼以回馈顾客，若顾客退还货品后，其购买金额未达到赠送满额礼的要求，则顾客需同时退回满额礼，若无法退回的，则满额礼的价值应由顾客承担，于退款中扣除，满额礼的价值参照相应正品的价值，按照比例进行计算。</p>
            <p>例如：希思黎全能乳液价值1800元，为125ML，体验装（或满额礼）为10ML，则价值为10/125*1800=144元。</p>
            <p>三、顾客在本网站订购产品，使用后如出现不适，可以随时申请退换货，但必须满足以下条件：</p>
            <p>1. 提供由中国大陆地区二级以上医院皮肤科出具的诊断报告；</p>
            <p>2. 诊断报告的出具日期系顾客签收货物之后；</p>
            <p>3. 诊断报告上明确指出该不适现象系由化妆品引起；</p>
            <p>凡出现上述情形，我们将退还相应的货款并承担因退换货而产生的运费。</p>
            <p>我们只受理从本网站销售的产品的退换货。凡是从本网站以外渠道购买的产品，请联系原购买地协商退换货；</p>
            <p>若产品是积分兑换的赠品，即使出现本规则中描述的情形，也不适用退换货服务；</p>
            <p>收件人：希思黎官网退货组</p>
            <p>退货地址：浙江省海宁市长安镇依江路8号3号楼1楼</p>
            <p>联系电话：17269385616</p>
            <p>16关于产品外包装及产品名字的补充说明</p>
            <p>因产品批次注册问题，为符合相关法律法规，您所收到的产品名字存在与页面描述不一致的可能性，但其实质为同一产品，敬请理解。</p>
          </article>
        </div>
      </div>
    </div>
    <!-- h5 -->
    <div class="m-refinements__refinement-bar m-useful-info__menu-mobile" v-if="showMenu">
      <div class="m-refinements__filter-header m-useful-info-bar-open">
        <div class="m-refinements__close-btn clearfix">
          <button class="c-button c-button--rounded float-right close" @click="showMenu=false">
            <svg
              class="svg-inline cross"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              width="12px"
              height="12px"
              viewBox="0 0 612 612"
              style="enable-background:new 0 0 612 612;"
              xml:space="preserve"
            >
              <g>
                <g id="cross">
                  <g>
                    <polygon
                      points="612,36.004 576.521,0.603 306,270.608 35.478,0.603 0,36.004 270.522,306.011 0,575.997 35.478,611.397 306,341.411 576.521,611.397 612,575.997 341.459,306.011"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </button>
        </div>
      </div>
      <div class="m-refinements__list clearfix">
        <div class="c-refinement c-toggler c-toggler--expanded">
          <a
            href="#"
            class="c-refinement__header c-toggler__title"
            @click="hideMenu=!hideMenu"
          >有用的信息</a>
          <div :class="['c-refinement__body',hideMenu?'c-toggler__content':'']">
            <ul class="c-refinement__values">
              <li
                title="销售条款"
                class="c-refinement__value"
                v-for="item in menuList"
                :key="item.name"
              >
                <a
                  :href="item.href"
                  :class="['c-refinement__value-link', selected==item.href?'selected':'']"
                >
                  <span class="c-refinement__value-link-name m-useful-info__menu-link">{{item.name}}</span>

                  <svg
                    v-if="selected==item.href"
                    class="svg-inline checkmark"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="15px"
                    height="15px"
                    viewBox="0 0 488.878 488.878"
                    style="enable-background:new 0 0 488.878 488.878;"
                    xml:space="preserve"
                  >
                    <g>
                      <g>
                        <polygon
                          style="fill:#000;"
                          points="143.294,340.058 50.837,247.602 0,298.439 122.009,420.447 122.149,420.306 144.423,442.58 488.878,98.123 437.055,46.298        "
                        />
                      </g>
                    </g>
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="m-refinements__apply-btn m-useful-info-bar-open">
        <button class="c-button c-button--secondary c-button--expand" @click="showMenu=false">应用</button>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";

export default {
  name: "TermsAndConditions",
  components: { Breadcrumb },
  data() {
    return {
      breadcrumb: {
        items: [{ text: "条款与条件", href: "" }]
      },
      showMenu: false,
      hideMenu: false,
      menuList: [
        { name: "法律声明", href: "/legal" },
        { name: "条款与条件", href: "/terms" },
        { name: "隐私条款", href: "/privacy" },
      ],
      selected: "",
    };
  },
  mounted() {
    if (this.$route.path) {
      this.selected = this.$route.path;
    }
  },
  methods: {
    clickMenu() {
      this.showMenu = !this.showMenu;
    },
    clickSelect(item) {
      this.showMenu = !this.showMenu;
      this.$router.push({ path: item.href });
    },
  },
};
</script>

<style lang="scss" scoped>
.m-useful-info { padding: 0 1.0625rem 3.75rem; }
.m-useful-info__container { padding: 3.125rem 0 0; }
.m-useful-info__title { text-align: center; font-size: 1.5265rem; margin-bottom: 1.875rem; }
.m-useful-info__menu-container { margin-bottom: 1.875rem; }
.menu-toggler {
  color: #000;
  line-height: 1.2;
  padding: 0.75rem 3.9375rem 0.75rem 2.0625rem;
  position: relative;
  cursor: pointer;
  border: 0.0625rem solid #cacaca;
  border-radius: 1.375rem;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
}
.c-toggler-content { display: none; }

.small { display: block; font-size: 10px; text-decoration: none; }
.article { padding-top: 70px; margin-top: -70px; }
.selectboxit-arrow-down, .selectboxit-arrow-up {
  display: block;
  width: 0.625rem;
  height: 0.625rem;
  background-image: url("../assets/imgs/icons/arrow.svg");
  background-repeat: no-repeat;
  background-position: 50%;
  position: absolute;
  right: 1.875rem;
}
.selectboxit-arrow-down { transform: rotateX(180deg); }
.selectboxit-arrow-up { transform: rotateX(0deg); }
.m-refinements__refinement-bar {
  position: fixed;
  right: 0;
  top: 0;
  transition: right 0.3s linear;
  background-color: #fff;
  height: 100%;
  width: 80%;
  z-index: 11;
}
.m-refinements__close-btn { padding: 1.5625rem 1.125rem 0.625rem 0; }
.c-toggler__title {
  position: relative;
  cursor: pointer;
  border-top: 0.0625rem solid #dfdfdf;
  border-bottom: 0.0625rem solid #dfdfdf;
  padding: 0.9375rem 0;
  margin-bottom: 0;
  display: block;
}
.c-refinement__header {
  font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
  font-size: 0.75rem;
  color: #000;
  border-top: none;
  padding: 1.5625rem 3.9375rem 1.5625rem 2.0625rem;
  text-decoration: none;
  display: block;
}
.c-refinement__body { background-color: #f5f5f5; padding: 0.9375rem 2.0625rem; }

.c-toggler__title:after {
  content: "";
  background: url("../assets/imgs/icons/arrow.svg") no-repeat;
  width: 0.9375rem;
  height: 0.5rem;
  right: 1.875rem;
  background-size: contain;
  position: absolute;
  top: 50%;
  transform: translateY(-50%) translateY(-0.5px);
}

.c-refinement__value-link {
  font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
  font-size: 0.75rem;
  color: #000;
  text-decoration: none;
  display: block;
  padding: 0.625rem 0 0.625rem 1.875rem;
}
.c-refinement__value-link.selected { text-decoration: underline; padding-left: 0; }
.c-refinement__value-link.selected .checkmark { float: left; margin: 0.125rem 0.9375rem 0 0; }
.m-refinements__apply-btn { padding: 2.5rem 2.0625rem 7.8125rem; }
.m-refinements__apply-btn .c-button { font-size: 0.625rem; font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif; padding: 0.8125rem 1.875rem; }
.c-button--expand { display: block; width: 100%; margin-right: 0; margin-left: 0; max-width: 100%; }
.c-button--secondary, .order-tracking-popin .c-order__cancel-wrapper .c-button--primary-reversed {
  display: inline-block;
  vertical-align: middle;
  padding: 0.8125rem 1.875rem;
  -webkit-appearance: none;
  border-radius: 1.375rem;
  transition: background-color 0.25s ease-out, color 0.25s ease-out;
  font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
  font-size: 0.625rem;
  line-height: 1;
  letter-spacing: 0.0625rem;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  text-transform: uppercase;
  background: transparent;
  border: 0.0625rem solid #cacaca;
  color: #000;
}
.c-toggler__content { display: none; }
@media screen and (max-width: 63.9375em) {
  .m-refinements__list { overflow-y: auto; height: calc(100vh - 276px); }
}
@media screen and (min-width: 48em) {
  .m-useful-info { padding: 0 3.875rem 3.75rem; }
  .m-refinements__refinement-bar { display: none; }
  .c-refinement {
    min-width: 13.4375rem;
    font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
    font-size: 0.75rem;
    color: #000;
    text-decoration: none;
    display: block;
    padding: 0.6875rem 1.25rem 0.6875rem 0.6875rem;
    cursor: pointer;
    border-radius: 0.5rem;
    &.selected { background-color: #f5f5f5; text-decoration: underline; }
  }
  .m-useful-info__title { text-align: left; float: left; }
  .m-useful-info__menu-container { float: right; }
  .c-toggler-content {
    display: block;
    position: absolute;
    z-index: 1;
    margin-top: 2.625rem;
    border-radius: 0.625rem;
    box-shadow: 0 0.3125rem 0.4375rem 0 hsla(0, 0%, 87.5%, 0.5);
    background-color: #fff;
    padding: 0.4375rem 0.5rem 0.5rem;
    right: 4rem;
  }
  .checkmark { float: right; }
}
@media screen and (min-width: 64em) {
  .breadcrumb { padding: 0 1.875rem; }
  .m-useful-info { padding: 0 1.875rem 3.75rem; }
  .m-useful-info__container { padding: 2.1875rem 6.25rem 0; }
  .m-useful-info__title { margin-bottom: 3.4375rem; }
  .m-useful-info__menu-container { margin-bottom: 3.4375rem; }
  .menu-toggler {
    border: 0.0625rem solid #cacaca; border-radius: 1.375rem; background-color: #fff;
    &:hover { background-color: #f5f5f5; }
  }
  .c-refinement {
    min-width: 14.6875rem;
    color: #575757;
    margin-top: 0.0625rem;
    border-radius: 0.5rem;
    min-width: 13.4375rem;
    white-space: nowrap;
    padding: 0.6875rem 1.25rem 0.6875rem 0.6875rem;
    &.selected { background-color: #f5f5f5; text-decoration: none; padding-left: 0.6875rem; }
  }
  .c-toggler-content { right: 7rem; }
}
@media screen and (min-width: 75em) {
  .m-useful-info { padding: 0 0 5rem; }
  .m-useful-info__container { padding: 2.1875rem 12.5rem 0; }
}
</style>